import React, { useState, useEffect, useMemo } from "react";
import { putProveedor, getProveedores } from "../helpers/rutaProveedores";
import { Modal, Button } from "react-bootstrap";
import { getLocalidades } from "../helpers/rutaLocalidades";
import { getIva } from "../helpers/rutaIva";
import "../css/modalformalert.css";
import { FaThumbsUp } from "react-icons/fa";

const ModalFormProveedor = ({ proveedor, handleClose }) => {
  // Soporta que te pasen { proveedores: {...} } o el objeto directo
  const prov = proveedor?.proveedores || proveedor || {};

  const [formValues, setFormValues] = useState({
    codprov: "",
    razonsocial: "",
    domicilio: "",
    telefono: "",
    cuit: "",
    email: "",
    localidad: "",      // ObjectId en string
    condicioniva: "",   // opcional si lo usás
  });

  useEffect(() => {
    // Si prov.localidad viene populado como objeto, tomar _id
    const localidadId =
      typeof prov.localidad === "object" ? prov.localidad?._id : prov.localidad;

    setFormValues({
      codprov: prov.codprov ?? "",
      razonsocial: prov.razonsocial ?? "",
      domicilio: prov.domicilio ?? "",
      telefono: prov.telefono ?? "",
      cuit: prov.cuit ?? "",
      email: prov.email ?? "",
      localidad: localidadId ?? "",
      condicioniva:
        typeof prov.condicioniva === "object"
          ? prov.condicioniva?._id ?? ""
          : prov.condicioniva ?? "",
    });
  }, [prov]);

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((s) => ({ ...s, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const id = prov._id; // id del proveedor a modificar
      if (!id) throw new Error("Falta _id del proveedor a modificar.");
      const resp = await putProveedor(id, formValues);
      if (resp?.ok === false) {
        alert(resp.error || "No se pudo guardar el proveedor");
        return;
      }
      setShowSuccessModal(true);
    } catch (err) {
      console.error("❌ Error PUT /proveedores:", err?.response || err);
      alert(`No se pudo guardar el proveedor${err?.response?.status ? ` (${err.response.status})` : ""}.`);
    }
  };

  const handleSuccessClose = () => {
    setShowSuccessModal(false);
    handleClose(); // cerrás el modal padre
  };

  // ------- Cargas auxiliares -------
  const [localidades, setLocalidades] = useState({ data: { localidades: [] }, loading: true, error: "" });
  const [ivas, setIvas] = useState({ data: { iva: [] }, loading: true, error: "" });

  useEffect(() => {
    (async () => {
      try {
        const locs = await getLocalidades();
        setLocalidades({ data: locs || { localidades: [] }, loading: false, error: "" });
      } catch (e) {
        setLocalidades({ data: { localidades: [] }, loading: false, error: e?.message || "Error al cargar localidades" });
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const iv = await getIva();
        setIvas({ data: iv || { iva: [] }, loading: false, error: "" });
      } catch (e) {
        setIvas({ data: { iva: [] }, loading: false, error: e?.message || "Error al cargar IVA" });
      }
    })();
  }, []);

  const opcionesLocalidades = useMemo(() => {
    return [...(localidades?.data?.localidades || [])]
      .filter((l) => l?.activo ?? true)
      .sort((a, b) =>
        (a.localidad || "").localeCompare(b.localidad || "", "es", { sensitivity: "base" })
      );
  }, [localidades]);

  if (localidades.loading || ivas.loading) return <div className="p-3">Cargando…</div>;
  if (localidades.error) return <div className="p-3 text-danger">{localidades.error}</div>;
  if (ivas.error) return <div className="p-3 text-danger">{ivas.error}</div>;

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          {/* Cod Prov, si querés editarlo, descomentá este bloque */}
          {/* <div className="form-group mt-3">
            <label>Cod. Prov</label>
            <input
              type="text"
              className="form-control"
              name="codprov"
              maxLength="20"
              required
              value={formValues.codprov}
              onChange={handleChange}
            />
          </div> */}

          <div className="form-group mt-3">
            <label>Razón Social</label>
            <input
              type="text"
              className="form-control"
              name="razonsocial"
              maxLength="50"
              required
              value={formValues.razonsocial}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-3">
            <label>Domicilio</label>
            <input
              type="text"
              className="form-control"
              name="domicilio"
              maxLength="50"
              required
              value={formValues.domicilio}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-3">
            <label>Teléfono</label>
            <input
              type="text"
              className="form-control"
              name="telefono"
              maxLength="30"
              value={formValues.telefono}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-3">
            <label>CUIT</label>
            <input
              type="text"
              className="form-control"
              name="cuit"
              maxLength="11"
              value={formValues.cuit}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-3">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              maxLength="50"
              value={formValues.email}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-3">
            <label>Localidad</label>
            <select
              className="form-control"
              name="localidad"
              value={formValues.localidad}
              onChange={handleChange}
              required
            >
              <option value="">Elija la opción adecuada</option>
              {opcionesLocalidades.map((localidad) => (
                <option key={localidad._id} value={localidad._id}>
                  {localidad.localidad}
                </option>
              ))}
            </select>
          </div>

          {/* Si activás Condición IVA en tu modelo/rutas, descomentá este bloque
          <div className="form-group mt-3">
            <label>Condición IVA</label>
            <select
              className="form-control"
              name="condicioniva"
              value={formValues.condicioniva}
              onChange={handleChange}
              required
            >
              <option value="">Elija la opción adecuada</option>
              {(ivas?.data?.iva || []).map((iva) => (
                <option key={iva._id} value={iva._id}>
                  {iva.iva}
                </option>
              ))}
            </select>
          </div>
          */}
        </Modal.Body>

        <Modal.Footer>
          <Button type="submit" variant="dark">
            Guardar
          </Button>
        </Modal.Footer>
      </form>

      {/* Modal de éxito */}
      <Modal show={showSuccessModal} onHide={handleSuccessClose} centered>
        <div className="custom-modal">
          <div className="custom-modal-icon">
            <FaThumbsUp />
          </div>
          <Modal.Body className="custom-modal-body">
            <h4>Info</h4>
            <p>¡Los cambios se guardaron correctamente!</p>
          </Modal.Body>
          <Button className="custom-modal-button" onClick={handleSuccessClose}>
            Aceptar
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default ModalFormProveedor;
